import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { BankModel, BankRequest, BankResourceService, PagedBankModel } from 'hx-services';

@Injectable({providedIn: 'root'})
export class BankService {
  constructor(
    private bankResourceService: BankResourceService,
  ) { }

  getBankList(params?: { page?: number; limit?: number; query?: string; ids?: number[] }): Promise<PagedBankModel> {
    return firstValueFrom(this.bankResourceService.getBanks(params?.ids, params?.limit, params?.page, params?.query));
  }

  getBank(id: number): Promise<BankModel> {
    return firstValueFrom(this.bankResourceService.getBankById(id));
  }

  createBank(body: BankRequest): Promise<BankModel> {
    return firstValueFrom(this.bankResourceService.saveBank(body));
  }

  updateBank(id: number, body: BankRequest): Promise<BankModel> {
    return firstValueFrom(this.bankResourceService.saveBank({...body, id}));
  }

  deleteBank(bankId: number): Promise<any> {
    return firstValueFrom(this.bankResourceService.removeBank(bankId));
  }
}
